import { render, staticRenderFns } from "./Paciente.vue?vue&type=template&id=2945cd8c&scoped=true"
import script from "./Paciente.vue?vue&type=script&lang=js"
export * from "./Paciente.vue?vue&type=script&lang=js"
import style0 from "./Paciente.vue?vue&type=style&index=0&id=2945cd8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2945cd8c",
  null
  
)

export default component.exports